const endpoint = "https://qepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${endpoint}`
const startpoint = `${cpoint}/qep/`

export { endpoint, mediapoint, startpoint }
